<template>
  <v-dialog v-model="dialog" max-width="600">
    <v-card>
      <v-card-title>
        <h3>Politica de Privacidade</h3>
        <v-spacer></v-spacer>
        <v-btn
          icon
          title="Fechar"
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div class="black--text mt-3 text-container">
          <p>Com o intuito de manter a privacidade e a segurança das informações de seus usuários, a (o) <span class="bold">Cometa Moto Center</span> adota as seguintes regras:</p>

          <p class="bold">Sobre o uso de suas Informações Pessoais:</p>

          <p>- A (o) <span class="bold">Cometa Moto Center</span> trata todas as informações de seus usuários com a máxima confidencialidade.</p>
          <p>- Não divulgamos, sem prévia autorização, em hipótese nenhuma, informações pessoais e/ou o e-mail do usuário que se cadastrar em páginas que requerem preenchimento desses dados.</p>
          <p>- Não cedemos ou comercializamos, sob nenhuma forma, qualquer informação individual de nossos usuários a terceiros.</p>
          <p>- Utilizamos as informações preenchidas (nome e e-mail) dos nossos usuários APENAS para comunicação sobre interesse em nossos produtos e dúvidas em geral.</p>
          <p>- Para cancelamento de seu cadastro no nosso banco de dados ou entrar em contato com a (o) <span class="bold">Cometa Moto Center</span>, favor entrar em contato através do formulário principal.</p>
          <p>- Preservamos a identidade do usuário, mantendo sigilo enquanto este navega nas páginas da (o) <span class="bold">Cometa Moto Center</span>. Para isso, o usuário deve se comprometer a respeitar as normas de segurança acima, assim como as normas específicas de cada serviço.</p>

          <p class="bold">Facebook e Instagram:</p>

          <p>Os dados solicitados neste site consideramos os dados de qualificação pessoal, como nome, telefone, e eventualmente outras necessárias para atender o propósito desta política.
          Funcionários da <span class="bold">Cometa Moto Center</span> poderão eventualmente entrar em contato via email ou telefone para tirar dúvidas ou apresentar novos produtos e serviços.
          Através de campanhas de publicidade, nós usamos cookies e tecnologias semelhantes (por exemplo, pixels e tags de anúncios) para coletar dados (como identificadores de dispositivos) para reconhecer você e/ou seu(s) dispositivo(s) onde você interagiu com nossos Serviços e dispositivos, dentro ou fora dele.</p>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-action>

      </v-card-action>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PoliticaPrivacidade',

  data() {
    return {
      dialog: false
    }
  },

  methods: {
    show(value = true) {
      this.dialog = value
    }
  }
}
</script>

<style lang="scss" scoped>
.bold {
  font-weight: 500 !important;
}

.text-container {
  font-size: 12pt !important;
  max-height: 500px !important;
  overflow-y: auto;
}
</style>